/* Quiz Tritania — frontend. Nessuna dipendenza. Stato in memoria + sessionStorage per la ripresa. */
(function () {
  const root = document.querySelector(".tq");
  if (!root) return;

  const API = root.dataset.api.replace(/\/$/, "");
  const LEAD_REQUIRED = root.dataset.leadRequired === "true";
  const PRIVACY = root.dataset.privacyUrl || "#";
  const IMPLICIT_CONSENT = root.dataset.consentMode === "implicit";
  const CONSENT_CHECKED = root.dataset.consentChecked === "true";
  const GO_TO_CART = root.dataset.goToCart !== "false";
  const VIDEO_ID = youtubeId(root.dataset.videoUrl || "");

  const QUESTIONS = [
    { key: "cooking_style", q: "Quale di queste descrive meglio il tuo modo di cucinare?", options: [
      ["HIGH_HEAT", "Rosolo spesso carne, pesce o verdure e lavoro anche ad alte temperature"],
      ["LONG_COOKING", "Preparo spesso sughi, pomodoro, risotti e cotture più lunghe"],
      ["VERSATILE", "Cucino un po' di tutto e cerco soprattutto versatilità"],
      ["DAILY_SIMPLE", "Faccio soprattutto preparazioni semplici e veloci di tutti i giorni"] ] },
    { key: "decision_driver", q: "Quando scegli una pentola o padella da usare per molti anni, qual è la prima cosa che vuoi avere chiara?", options: [
      ["MATERIALS", "Di quali materiali è fatta e cosa entra a contatto con il cibo"],
      ["PERFORMANCE", "Come si comporta davvero durante la cottura"],
      ["DURABILITY", "Quanto è costruita per durare nel tempo"],
      ["TRUST", "Chi c'è dietro al prodotto e a chi posso rivolgermi se ho bisogno"] ] },
    { key: "capacity", q: "Quando cucini, per quante persone prepari più spesso?", options: [
      ["SMALL", "1 o 2 persone"], ["MEDIUM", "3 o 4 persone"], ["LARGE", "5 o più persone"],
      ["FLEXIBLE", "Dipende, mi capita spesso di cucinare anche per ospiti"] ] },
    { key: "scope", q: "Se trovassi la soluzione giusta per il tuo modo di cucinare, da dove preferiresti partire?", options: [
      ["SINGLE", "Da una sola pentola o padella che userei molto spesso"],
      ["CORE_SET", "Da 2 o 3 pezzi essenziali, scelti bene"],
      ["BATTERY", "Da una batteria completa, per avere una soluzione coordinata"],
      ["GUIDED", "Non lo so ancora, preferisco farmi consigliare"] ] },
  ];

  // ---------- stato ----------
  const state = {
    quizId: sessionStorage.getItem("tq_quiz_id") || uuid(),
    step: 0, answers: {}, result: null, pending: null, source: readSource(),
  };
  sessionStorage.setItem("tq_quiz_id", state.quizId);

  const $ = (sel, el = root) => el.querySelector(sel);
  const flow = $(".tq-flow"), stepEl = $("[data-tq-step]"), resultEl = $("[data-tq-result]");
  const backBtn = $("[data-tq-back]"), progress = [...root.querySelectorAll(".tq-progress li")];
  const tpl = (name) => $(`[data-tq-tpl="${name}"]`).content.cloneNode(true);

  $("[data-tq-start]").addEventListener("click", () => { track("quiz_start"); $(".tq-head").hidden = true; flow.hidden = false; render(); });
  backBtn.addEventListener("click", () => { if (state.step > 0) { state.step--; render(); } });

  // ---------- rendering ----------
  function render() {
    stepEl.innerHTML = "";
    progress.forEach((li, i) => { li.className = i < state.step ? "is-done" : i === state.step ? "is-current" : ""; });
    backBtn.hidden = state.step === 0;
    if (state.step < 4) renderQuestion(QUESTIONS[state.step]);
    else if (state.step === 4) renderOpen();
    else if (state.step === 5) renderLead();
    window.scrollTo({ top: root.offsetTop - 20, behavior: "smooth" });
    track("quiz_step", { step: state.step + 1 });
  }

  function renderQuestion(def) {
    const f = tpl("question");
    f.querySelector(".tq-count").textContent = `Domanda ${state.step + 1} di 5`;
    f.querySelector(".tq-q").textContent = def.q;
    const box = f.querySelector(".tq-options");
    def.options.forEach(([val, label]) => {
      const b = document.createElement("button");
      b.type = "button"; b.className = "tq-option" + (state.answers[def.key] === val ? " is-selected" : "");
      b.setAttribute("role", "radio"); b.setAttribute("aria-checked", String(state.answers[def.key] === val));
      b.textContent = label;
      b.addEventListener("click", () => { state.answers[def.key] = val; b.classList.add("is-selected"); setTimeout(() => { state.step++; render(); }, 220); });
      box.appendChild(b);
    });
    stepEl.appendChild(f);
  }

  function renderOpen() {
    const f = tpl("open");
    const ta = f.querySelector("textarea"); ta.value = state.answers.open_answer || "";
    f.querySelector("[data-tq-open-next]").addEventListener("click", () => {
      state.answers.open_answer = ta.value.trim();
      state.pending = requestRecommendation();           // parte subito: il risultato è pronto mentre l'utente scrive l'email
      if (LEAD_REQUIRED) { state.step = 5; render(); } else showResultWhenReady();
    });
    stepEl.appendChild(f);
  }

  function renderLead() {
    const f = tpl("lead");
    f.querySelectorAll("[data-tq-privacy]").forEach((a) => { a.href = PRIVACY; });
    if (IMPLICIT_CONSENT) { f.querySelector("[data-tq-consent-row]").hidden = true; f.querySelector("[data-tq-privacy-checkbox]").hidden = true; f.querySelector("[data-tq-privacy-implicit]").hidden = false; }
    const name = f.querySelector("[data-tq-name]"), email = f.querySelector("input[type=email]"), consent = f.querySelector("[data-tq-consent]");
    if (!IMPLICIT_CONSENT) consent.checked = CONSENT_CHECKED;
    const err = f.querySelector("[data-tq-lead-error]"), btn = f.querySelector("[data-tq-lead-submit]");
    btn.addEventListener("click", async () => {
      if (!name.value.trim()) { err.hidden = false; err.textContent = "Scrivi il tuo nome, così la proposta arriva a te."; name.focus(); return; }
      if (!email.checkValidity()) { err.hidden = false; err.textContent = "Controlla l'indirizzo email: sembra incompleto."; return; }
      err.hidden = true; btn.disabled = true; btn.textContent = "Un attimo…";
      let res = null;
      try { res = await state.pending; } catch (_) { /* gestito sotto */ }
      const eventId = "lead_" + state.quizId;
      if (typeof fbq === "function") fbq("track", "Lead", { content_name: "quiz_tritania" }, { eventID: eventId });
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish("quiz_lead", { quiz_id: state.quizId, event_id: eventId });
      post("/v1/lead", { quiz_id: state.quizId, first_name: name.value.trim(), email: email.value.trim(), marketing_consent: IMPLICIT_CONSENT || consent.checked, source: state.source,
        event_id: eventId, fbp: cookie("_fbp"), fbc: cookie("_fbc") || fbcFromUrl(), page_url: location.href,
        quiz: { ...state.answers, recommended_handle: res?.recommendation?.handle, recommended_title: res?.recommendation?.title, alternative_handle: res?.alternative?.handle, open_tags: (res?.meta?.affinity_tags || []).concat(res?.meta?.message_tags || []) } })
        .catch(() => {});
      state.leadGiven = true;
      showResultWhenReady();
    });
    stepEl.appendChild(f);
  }

  async function showResultWhenReady() {
    stepEl.innerHTML = ""; stepEl.appendChild(tpl("loading"));
    const txt = $("[data-tq-loading-text]");
    const t = setTimeout(() => { if (txt) txt.textContent = "Preparo la proposta…"; }, 1800);
    try {
      state.result = await state.pending;
      renderResult(state.result);
    } catch (e) {
      stepEl.innerHTML = `<p class="tq-error">Non riusciamo a calcolare la proposta in questo momento. <button class="tq-link" type="button" data-tq-retry>Riprova</button></p>`;
      $("[data-tq-retry]").addEventListener("click", () => { state.pending = requestRecommendation(); showResultWhenReady(); });
    } finally { clearTimeout(t); }
  }

  function renderResult(r) {
    flow.hidden = true; resultEl.hidden = false;
    const p = r.recommendation, a = r.alternative, c = r.copy;
    const eur = (n) => Number(n).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
    resultEl.innerHTML = `
      <div class="tq-result-head">
        <p class="tq-count">La proposta per te</p>
        <h2 class="tq-q">${esc(c.headline).replace(/\*\*/g, "")}</h2>
        <p class="tq-result-summary">${md(c.summary)}</p>
      </div>
      <div class="tq-product">
        ${p.image ? `<img src="${p.image}&width=600" alt="${esc(p.title)}" loading="lazy">` : ""}
        <div>
          <h3>${esc(p.title)}</h3>
          ${p.units.includes(",") ? `<p class="tq-units">Contiene: ${esc(p.units)}</p>` : ""}
          <p class="tq-price">${eur(p.price)}${p.compare_at && p.compare_at > p.price ? `<s>${eur(p.compare_at)}</s>` : ""}</p>
          ${p.savings_vs_singles ? `<p class="tq-savings">${eur(p.savings_vs_singles)} in meno rispetto ai pezzi presi singolarmente</p>` : `<p class="tq-savings"></p>`}
          ${state.leadGiven && r.discount ? `<p class="tq-discount">Il tuo codice: <strong>${esc(r.discount.code)}</strong> · ${r.discount.percent}% di sconto, lo applichiamo noi al carrello.</p>` : ""}
          <div class="tq-actions">
            <button class="tq-btn tq-btn--primary" type="button" data-tq-add="${p.variant_id}" data-tq-handle="${p.handle}">Aggiungi al carrello</button>
            <a class="tq-btn tq-btn--ghost" href="/products/${p.handle}" data-tq-view="${p.handle}">Vedi la scheda</a>
          </div>
          <p class="tq-added" data-tq-added hidden></p>
        </div>
      </div>
      <div class="tq-why"><h4>Perché questa proposta</h4><ul>${c.why_this_product.map((x) => `<li>${md(x)}</li>`).join("")}</ul></div>
      <div class="tq-proof"><h4>Quello che conta per te</h4><ul>${c.proof_points.map((x) => `<li>${md(x)}</li>`).join("")}</ul></div>
      ${VIDEO_ID ? `<div class="tq-video">
        <h4>${esc(root.dataset.videoTitle || "Chi c'è dietro le pentole Tritania")}</h4>
        ${root.dataset.videoText ? `<p>${esc(root.dataset.videoText)}</p>` : ""}
        <button class="tq-video-poster" type="button" data-tq-play aria-label="Guarda il video" style="background-image:url('https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg')"><span class="tq-play"></span></button>
      </div>` : ""}
      <div class="tq-alt">
        ${a.image ? `<img src="${a.image}&width=200" alt="" loading="lazy">` : "<span></span>"}
        <div>
          <p><strong>${a.relation === "BUDGET" ? "Per iniziare con meno" : a.relation === "ENTRY" ? "Se preferisci un solo pezzo" : "Se vuoi una soluzione più ampia"}: ${esc(a.title)}</strong>
          ${md(c.alternative_note)}</p>
          <p class="tq-alt-price">${eur(a.price)}${a.savings_vs_singles ? ` <span>· ${eur(a.savings_vs_singles)} in meno rispetto ai singoli</span>` : ""}</p>
          <div class="tq-actions tq-actions--small">
            <button class="tq-btn tq-btn--primary" type="button" data-tq-add="${a.variant_id}" data-tq-handle="${a.handle}" data-tq-alt-add>Aggiungi al carrello</button>
            <a class="tq-btn tq-btn--ghost" href="/products/${a.handle}" data-tq-alt="${a.handle}">Vedi la scheda</a>
          </div>
          <p class="tq-added" data-tq-added-alt hidden></p>
        </div>
      </div>
      <p class="tq-restart"><button class="tq-link" type="button" data-tq-restart>Rifai il quiz</button></p>`;

    track("result_view", { primary: p.handle, alternative: a.handle, fallback: r.meta.fallback_used });
    root.querySelectorAll("[data-tq-add]").forEach((b) => b.addEventListener("click", (e) => addToCart(e.currentTarget)));
    $("[data-tq-view]").addEventListener("click", () => track("recommendation_click", { handle: p.handle }));
    $("[data-tq-alt]").addEventListener("click", () => track("alternative_click", { handle: a.handle }));
    $("[data-tq-restart]").addEventListener("click", () => { sessionStorage.removeItem("tq_quiz_id"); location.reload(); });
    const play = $("[data-tq-play]");
    if (play) play.addEventListener("click", () => {
      track("video_play", { video: VIDEO_ID });
      const wrap = document.createElement("div"); wrap.className = "tq-video-frame";
      wrap.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0" title="Video Tritania" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>`;
      play.replaceWith(wrap);
    });
    window.scrollTo({ top: root.offsetTop - 20, behavior: "smooth" });
  }

  // ---------- azioni ----------
  async function addToCart(btn) {
    btn.disabled = true; btn.textContent = "Aggiungo…";
    try {
      await fetch("/cart/update.js", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ attributes: { quiz_id: state.quizId } }) });
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.tqAdd), quantity: 1, properties: { _quiz_id: state.quizId } }] }) });
      if (!res.ok) throw new Error("cart");
      track("add_to_cart", { handle: btn.dataset.tqHandle, variant_id: btn.dataset.tqAdd });
      const code = state.leadGiven && state.result?.discount?.code;
      const cartUrl = code ? `/discount/${encodeURIComponent(code)}?redirect=/cart` : "/cart";
      if (GO_TO_CART) { btn.textContent = "Vado al carrello…"; location.href = cartUrl; return; }
      btn.textContent = "Aggiunto";
      const ok = btn.hasAttribute("data-tq-alt-add") ? $("[data-tq-added-alt]") : $("[data-tq-added]"); ok.hidden = false;
      ok.innerHTML = `Nel carrello${code ? `, con il codice ${esc(code)} applicato` : ""}. <a href="${cartUrl}">Vai al carrello</a>`;
    } catch (_) { btn.disabled = false; btn.textContent = "Aggiungi al carrello"; location.href = `/products/${btn.dataset.tqHandle}`; }
  }

  function requestRecommendation() {
    const a = { cooking_style: state.answers.cooking_style, decision_driver: state.answers.decision_driver, capacity: state.answers.capacity, scope: state.answers.scope };
    if (state.answers.open_answer) a.open_answer = state.answers.open_answer;
    return post("/v1/recommend", { quiz_id: state.quizId, answers: a, source: state.source, locale: "it" });
  }

  async function post(path, body) {
    const res = await fetch(API + path, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body) });
    if (!res.ok) throw new Error(path + " " + res.status);
    return res.json();
  }

  function track(event, payload = {}) {
    (window.dataLayer = window.dataLayer || []).push({ event: "tq_" + event, quiz_id: state.quizId, ...payload });
    const ev = { quiz_id: state.quizId, event, payload };
    if (event === "quiz_complete") return;                     // registrato dal backend
    (navigator.sendBeacon && navigator.sendBeacon(API + "/v1/event", new Blob([JSON.stringify(ev)], { type: "application/json" }))) || post("/v1/event", ev).catch(() => {});
  }

  // ---------- utilità ----------
  function readSource() {
    const u = new URLSearchParams(location.search), out = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"].forEach((k) => { const v = u.get(k); if (v) out[k] = v.slice(0, 120); });
    const saved = sessionStorage.getItem("tq_source");
    if (Object.keys(out).length) sessionStorage.setItem("tq_source", JSON.stringify(out));
    return Object.keys(out).length ? out : (saved ? JSON.parse(saved) : {});
  }
  function youtubeId(url) { const m = String(url).match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([A-Za-z0-9_-]{11})/); return m ? m[1] : ""; }
  function cookie(name) { const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)")); return m ? decodeURIComponent(m[1]) : ""; }
  function fbcFromUrl() { const id = new URLSearchParams(location.search).get("fbclid"); return id ? `fb.1.${Date.now()}.${id}` : ""; }
  function uuid() { return crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => { const r = Math.random() * 16 | 0; return (c === "x" ? r : (r & 3 | 8)).toString(16); }); }
  function md(s) { return esc(s).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>"); }
  function esc(s) { return String(s ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])); }
})();